import appraisalPort from "apis/appraisalPort";
import { WebApiRequest, HTTP_GET, HTTP_PUT, HTTP_POST } from "../../tools/webservice";

export const getIsIntegrated = (customerNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: appraisalPort.isIntegrated(customerNumber),
  successCallback,
  mountedRef
});

export const getStatus = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: appraisalPort.status(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});

export const getHoldReasons = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: appraisalPort.holdReasons(),
  successCallback,
  mountedRef
});

export const putOnHold = (controlIdNumber, reasonId, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: appraisalPort.onHold(controlIdNumber, reasonId),
  successCallback,
  errorCallback,
  mountedRef
});

export const putOffHold = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: appraisalPort.offHold(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});

export const sendMessage = (controlIdNumber, subject, body, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: {
    subject,
    body
  },
  endpoint: appraisalPort.message(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});

export const acceptOrder = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/integrations/appraisal-port/cases/${controlIdNumber}/accept`,
  successCallback,
  errorCallback,
  mountedRef
});

export const declineOrder = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/integrations/appraisal-port/cases/${controlIdNumber}/decline`,
  successCallback,
  errorCallback,
  mountedRef
});